module.exports = __webpack_public_path__ + "static/media/attachment-1.66b52c58.jpg";